// import React, { useEffect, useState } from "react";
// import { Card, Col, Row, Typography, Tag, Image, Spin } from "antd";
// import { useNavigate, useParams } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { asyncStatus } from "../../utils/asyncStatus";
// import { getProductByIdAsync } from "../../services/ProductManagementServices";

// const { Title, Text } = Typography;

// const ProductDetail = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [storeStatus, setStoreStatus] = useState("");
//   const { get_product_by_id_data, get_product_by_id_status } = useSelector(
//     (state) => state.productManagement
//   );

//   const productLoader = get_product_by_id_status === asyncStatus.LOADING;

//   useEffect(() => {
//     dispatch(getProductByIdAsync(id));
//   }, [id, dispatch]);

//   if (productLoader) {
//     return (
//       <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
//         <div className="flex items-center justify-center h-[40vh]">
//           <Spin size="large" className="flex justify-center" />
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="flex justify-center p-6">
//       <Card className="max-w-4xl w-full shadow-lg rounded-xl overflow-hidden p-4">
//         <Row gutter={[24, 24]}>
//           <Col xs={24} md={12} className="flex flex-col items-center gap-2">
//             {get_product_by_id_data?.images?.length > 0 ? (
//               <Image.PreviewGroup>
//                 {get_product_by_id_data?.images?.map((image, index) => (
//                   <Image
//                     key={index}
//                     src={image}
//                     alt={`Product Image ${index}`}
//                     className="rounded-md shadow-md mb-2"
//                     width={200}
//                   />
//                 ))}
//               </Image.PreviewGroup>
//             ) : (
//               <Text type="secondary">No images available</Text>
//             )}
//           </Col>

//           <Col xs={24} md={12} className="flex flex-col gap-4">
//             <Title level={3} className="text-center">
//               {get_product_by_id_data?.name}
//             </Title>

//             {/* SKU */}
//             {get_product_by_id_data?.sku && (
//               <Text>
//                 <strong>SKU: &nbsp;</strong> {get_product_by_id_data?.sku}
//               </Text>
//             )}

//             {/* GTIN Number */}
//             {get_product_by_id_data?.gtin_number && (
//               <Text>
//                 <strong>GTIN Number: &nbsp;</strong>{" "}
//                 {get_product_by_id_data?.gtin_number}
//               </Text>
//             )}

//             {/* Category */}
//             {get_product_by_id_data?.category?.length > 0 && (
//               <Text>
//                 <strong>Category: &nbsp;</strong>
//                 {get_product_by_id_data?.category
//                   ?.map((cat) => cat.name)
//                   .join(", ")}
//               </Text>
//             )}

//             {/* Availability */}
//             {get_product_by_id_data?.availability && (
//               <Text>
//                 <strong>Availability: &nbsp;</strong>
//                 <Tag
//                   color={
//                     get_product_by_id_data?.availability === "In-Stock"
//                       ? "green"
//                       : "red"
//                   }
//                 >
//                   {get_product_by_id_data?.availability}
//                 </Tag>
//               </Text>
//             )}

//             {/* Status */}
//             {get_product_by_id_data?.status && (
//               <Text>
//                 <strong>Status: &nbsp;</strong>
//                 <Tag
//                   color={
//                     get_product_by_id_data?.status === "Active"
//                       ? "green"
//                       : "red"
//                   }
//                 >
//                   {get_product_by_id_data?.status}
//                 </Tag>
//               </Text>
//             )}

//             {/* Stores */}
//             {get_product_by_id_data?.stores?.length > 0 && (
//               <div>
//                 <Text strong>Stores:</Text>
//                 <div className="flex flex-wrap gap-2 mt-1">
//                   {get_product_by_id_data?.stores?.map((store, index) => (
//                     <Tag key={index} color="blue">
//                       {store.name}
//                     </Tag>
//                   ))}
//                 </div>
//               </div>
//             )}

//             {/* Variants */}
//             {get_product_by_id_data?.variants?.length > 0 && (
//               <div>
//                 <Text strong>Variants:</Text>
//                 {get_product_by_id_data?.variants?.map((variant, index) => (
//                   <div
//                     key={index}
//                     className="mt-2 p-2 border rounded-md flex flex-col bg-gray-100"
//                   >
//                     <Text>
//                       <strong>Size: &nbsp;</strong> {variant?.size?.name}
//                     </Text>
//                     <Text>
//                       <strong>sku: &nbsp;</strong> {variant?.sku}
//                     </Text>
//                     <Text>
//                       <strong>Fabric: &nbsp;</strong> {variant?.Fabric}
//                     </Text>
//                     <Text>
//                       <strong>Finishing: &nbsp;</strong> {variant?.Finishing}
//                     </Text>
//                     <Text>
//                       <strong>Price: &nbsp;</strong> ${variant?.price}
//                     </Text>
//                     <Text>
//                       <strong>Discount: &nbsp;</strong> ${variant?.discount}
//                     </Text>
//                     <Text>
//                       <strong>Discount Price: &nbsp;</strong>$
//                       {variant?.price && variant?.discount
//                         ? (variant.price - variant?.discount).toFixed(2)
//                         : variant?.price}
//                       {/* {variant?.price && variant?.discount
//                         ? (
//                             variant.price - 
//                             (variant.price * variant.discount) / 100
//                           ).toFixed(2)
//                         : variant?.price} */}
//                     </Text>
//                     <Text>
//                       <strong>Stock Quantity: &nbsp;</strong>{" "}
//                       {variant.stock_quantity}
//                     </Text>
//                   </div>
//                 ))}
//               </div>
//             )}

//             {/* Description */}
//             {get_product_by_id_data?.description && (
//               <div>
//                 <Text strong>Description:</Text>
//                 <div
//                   className="mt-2 p-2 border rounded-md bg-gray-100"
//                   dangerouslySetInnerHTML={{
//                     __html: get_product_by_id_data?.description,
//                   }}
//                 />
//               </div>
//             )}

//             {/* FAQs */}
//             {get_product_by_id_data?.faqs?.length > 0 && (
//               <div>
//                 <Text strong>Starting Price</Text>
//                 <div className="mt-2">
//                   <Text strong>
//                     ${get_product_by_id_data?.starting_price.toLocaleString()}
//                   </Text>
//                 </div>
//               </div>
//             )}
//             {/* FAQs */}
//             {get_product_by_id_data?.faqs?.length > 0 && (
//               <div>
//                 <Text strong>FAQs:</Text>
//                 {get_product_by_id_data?.faqs?.map((faq, index) => (
//                   <div key={index} className="mt-2">
//                     <Text strong>Q: {faq?.question}</Text>
//                     <br />
//                     <Text>A: {faq?.answer}</Text>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </Col>
//         </Row>
//       </Card>
//     </div>
//   );
// };

// export default ProductDetail;



import React, { useEffect, useState } from "react";
import { 
  Card, 
  Col, 
  Row, 
  Typography, 
  Tag, 
  Image, 
  Spin, 
  Divider, 
  Tabs, 
  Badge, 
  Carousel, 
  Empty, 
  Collapse, 
  Descriptions,
  Breadcrumb
} from "antd";
import { 
  ShoppingOutlined, 
  TagOutlined, 
  InfoCircleOutlined, 
  QuestionCircleOutlined, 
  PictureOutlined,
  HomeOutlined,
  RightOutlined,
  CheckCircleFilled,
  CloseCircleFilled
} from "@ant-design/icons";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { asyncStatus } from "../../utils/asyncStatus";
import { getProductByIdAsync } from "../../services/ProductManagementServices";

const { Title, Text, Paragraph } = Typography;
const { TabPane } = Tabs;
const { Panel } = Collapse;

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const { get_product_by_id_data, get_product_by_id_status } = useSelector(
    (state) => state.productManagement
  );

  const productLoader = get_product_by_id_status === asyncStatus.LOADING;

  useEffect(() => {
    dispatch(getProductByIdAsync(id));
  }, [id, dispatch]);

  const handleImageSelect = (index) => {
    setActiveImageIndex(index);
  };

  if (productLoader) {
    return (
      <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
        <div className="flex items-center justify-center h-[60vh]">
          <Spin size="large" tip="Loading product details..." />
        </div>
      </div>
    );
  }

  // Check if product data exists
  if (!get_product_by_id_data) {
    return (
      <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
        <Empty
          description="Product not found"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </div>
    );
  }

  const { 
    name, 
    sku, 
    gtin_number, 
    category, 
    availability, 
    status, 
    stores, 
    variants, 
    description, 
    faqs, 
    starting_price,
    images 
  } = get_product_by_id_data;

  return (
    <div className="container mx-auto py-6 px-4">
      <Breadcrumb className="mb-4">
        <Breadcrumb.Item>
          <Link to="/">
            <HomeOutlined /> Home
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to="/products">Products</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{name}</Breadcrumb.Item>
      </Breadcrumb>
      
      <Card className="shadow-lg rounded-xl overflow-hidden">
        <Row gutter={[32, 32]}>
          {/* Left Column - Product Images */}
          <Col xs={24} lg={12}>
            <div className="product-gallery">
              {images?.length > 0 ? (
                <>
                  <div className="main-image-container mb-4 flex justify-center items-center bg-gray-50 rounded-lg overflow-hidden" style={{ height: "400px" }}>
                    <Image
                      src={images[activeImageIndex]}
                      alt={`${name} - Image ${activeImageIndex + 1}`}
                      className="object-contain"
                      style={{ maxHeight: "100%" }}
                      preview={{
                        mask: <div className="flex items-center justify-center"><PictureOutlined /> Preview</div>
                      }}
                    />
                  </div>
                  
                  <div className="thumbnail-gallery flex overflow-x-auto gap-2 pb-2">
                    {images.map((image, index) => (
                      <div 
                        key={index}
                        className={`thumbnail-item cursor-pointer border-2 rounded ${index === activeImageIndex ? 'border-blue-500' : 'border-transparent'}`}
                        onClick={() => handleImageSelect(index)}
                      >
                        <Image
                          src={image}
                          alt={`Thumbnail ${index + 1}`}
                          width={70}
                          height={70}
                          className="object-cover rounded"
                          preview={false}
                        />
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div className="flex items-center justify-center h-[300px] bg-gray-100 rounded-lg">
                  <Empty description="No images available" />
                </div>
              )}
            </div>
          </Col>
          
          {/* Right Column - Product Details */}
          <Col xs={24} lg={12} className="flex flex-col">
            <div className="product-info">
              <div className="mb-2 flex flex-wrap gap-2">
                {category?.map((cat) => (
                  <Tag key={cat._id} color="blue">{cat.name}</Tag>
                ))}
              </div>
              
              <Title level={2} className="mb-4">{name}</Title>
              
              {starting_price && (
                <div className="price-container mb-6">
                  <Text className="text-3xl font-semibold text-blue-600">
                    ${starting_price.toLocaleString()}
                  </Text>
                </div>
              )}
              
              <div className="product-meta mb-6">
                <Descriptions bordered size="small" column={1} className="bg-gray-50 rounded-lg">
                  {sku && (
                    <Descriptions.Item label="SKU">{sku}</Descriptions.Item>
                  )}
                  
                  {gtin_number && (
                    <Descriptions.Item label="GTIN Number">{gtin_number}</Descriptions.Item>
                  )}
                  
                  {availability && (
                    <Descriptions.Item label="Availability">
                      <Badge 
                        status={availability === "In-Stock" ? "success" : "error"} 
                        text={availability} 
                      />
                    </Descriptions.Item>
                  )}
                  
                  {status && (
                    <Descriptions.Item label="Status">
                      <Badge 
                        status={status === "Active" ? "success" : "error"} 
                        text={status} 
                      />
                    </Descriptions.Item>
                  )}
                </Descriptions>
              </div>
            </div>
            
            <Divider />
            
            {/* Stores */}
            {stores?.length > 0 && (
              <div className="mb-6">
                <Title level={5}>Available at Stores</Title>
                <div className="flex flex-wrap gap-2 mt-2">
                  {stores.map((store) => (
                    <Tag key={store._id} color="purple" icon={<ShoppingOutlined />}>
                      {store.name}
                    </Tag>
                  ))}
                </div>
              </div>
            )}
          </Col>
        </Row>
        
        {/* Tabs for Additional Information */}
        <Tabs defaultActiveKey="variants" className="mt-8" type="card">
          {/* Variants Tab */}
          <TabPane 
            tab={<span><TagOutlined /> Variants ({variants?.length || 0})</span>} 
            key="variants"
          >
            {variants?.length > 0 ? (
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200 rounded-lg overflow-hidden">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 border-b text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Size</th>
                      <th className="px-6 py-3 border-b text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fabric</th>
                      <th className="px-6 py-3 border-b text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Finishing</th>
                      <th className="px-6 py-3 border-b text-left text-xs font-medium text-gray-500 uppercase tracking-wider">SKU</th>
                      <th className="px-6 py-3 border-b text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
                      <th className="px-6 py-3 border-b text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Stock</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {variants.map((variant, index) => (
                      <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                        <td className="px-6 py-4 whitespace-nowrap text-sm">{variant?.size?.name}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm">{variant?.Fabric}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm">{variant?.Finishing}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-mono">{variant?.sku}</td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm font-medium">
                            ${variant?.price}
                            {variant?.discount > 0 && (
                              <>
                                <span className="line-through text-gray-400 ml-2">${variant?.discount}</span>
                                <span className="text-green-600 ml-2">
                                  ${(variant.price - variant?.discount).toFixed(2)}
                                </span>
                              </>
                            )}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <Badge
                            status={variant.stock_quantity > 0 ? "success" : "error"}
                            text={variant.stock_quantity > 0 ? `${variant.stock_quantity} in stock` : "Out of stock"}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <Empty description="No variants available for this product" />
            )}
          </TabPane>
          
          {/* Description Tab */}
          <TabPane 
            tab={<span><InfoCircleOutlined /> Description</span>} 
            key="description"
          >
            {description ? (
              <div 
                className="product-description p-4 bg-white rounded-lg border border-gray-200"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            ) : (
              <Empty description="No description available" />
            )}
          </TabPane>
          
          {/* FAQs Tab */}
          <TabPane 
            tab={<span><QuestionCircleOutlined /> FAQs ({faqs?.length || 0})</span>} 
            key="faqs"
          >
            {faqs?.length > 0 ? (
              <Collapse accordion className="bg-white border border-gray-200 rounded-lg">
                {faqs.map((faq, index) => (
                  <Panel 
                    key={index} 
                    header={<span className="font-medium">{faq.question}</span>}
                  >
                    <Paragraph>{faq.answer}</Paragraph>
                  </Panel>
                ))}
              </Collapse>
            ) : (
              <Empty description="No FAQs available for this product" />
            )}
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default ProductDetail;